import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgDownload from '../../../others/svg_dist/Download';

type Props = {
	Icon: JSX.Element;
	title: string;
	size: string;
	editDate: string;
	href: string;
};

type State = {};

class FileItem extends Component<Props, State> {
	state = {};

	downloadFile = (href: string) => {
		const tempAnchor = document.createElement('a');
		tempAnchor.href = href;
		tempAnchor.target = '_blank';
		tempAnchor.click();
	};

	render() {
		return (
			<Styles.FileItemWrapper
				onClick={() => this.downloadFile(this.props.href)}
			>
				<Styles.FileItemIconContainer>
					{this.props.Icon}
				</Styles.FileItemIconContainer>
				<Styles.FileItemTitleContainer>
					<p className="title">{this.props.title}</p>
				</Styles.FileItemTitleContainer>
				<Styles.FileItemDataContainer>
					<p className="meta">{this.props.size}</p>
					<p className="meta">{this.props.editDate}</p>
				</Styles.FileItemDataContainer>
				<Styles.DownloadButton className="download">
					<SvgDownload />
				</Styles.DownloadButton>
			</Styles.FileItemWrapper>
		);
	}
}

export default FileItem;
